import taskTemplatesUrl from './taskTemplates.html';

class TaskTemplatesCtrl {
  constructor(Authentication, AlertService, ShiftTasksService, SlingApi, TaskTemplatesService) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      AlertService,
      ShiftTasksService,
      SlingApi,
      TaskTemplatesService,
    });
  }

  $onInit() {
    if (this.canDisplayContent) {
      this.TaskTemplatesService.loadTemplates();
    }
  }

  get canDisplayContent() {
    return this.ShiftTasksService.isFeatureEnabled;
  }

  get templates() {
    return this.TaskTemplatesService.templates;
  }
}

export default {
  templateUrl: taskTemplatesUrl,
  controller: TaskTemplatesCtrl,
  controllerAs: 'ctrl',
};
